$(() => {
    $('body').on('click', '.js-product-btn', function () {
        const productName = $(this).data('name');
        $('.js-order-product-name').text(productName);
    });
});


// WEBPACK FOOTER //
// ./markup/components/modal/modal.js